// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import he from 'he';

//HOOKS
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";


// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";

interface ServicesProps {
    agencyId: number;
}

const Services: React.FC<ServicesProps> = ({agencyId}) => {

    const { t } = useTranslation();

    const { agency } = useGetAgencyDetails(agencyId);

    return (
        <>
            <Helmet>
                <title>{t('servicesPage.pageTitle')} | {he.decode(`${agency?.agencyName}`) || 'Agenzia Immobiliare'}</title>
            </Helmet>

            <SubHeaderDefault title={t('servicesPage.subHeaderTitle')} isSeo={true} />

            <main id="services-page" className="space-ptb bg-custom">
                <img src="/assets/images/rainbow.png" alt="rainbow" className="rainbow" />
                <div className="container-fluid w-special">
                    <p className="w-para mb-4" dangerouslySetInnerHTML={{ __html: t('servicesPage.para1') as string }} />
                    <ul>
                        <li className="w-para" dangerouslySetInnerHTML={{ __html: t('servicesPage.listItem1') as string }} />
                        <li className="w-para" dangerouslySetInnerHTML={{ __html: t('servicesPage.listItem2') as string }} />
                        <li className="w-para" dangerouslySetInnerHTML={{ __html: t('servicesPage.listItem3') as string }} />
                        <li className="w-para" dangerouslySetInnerHTML={{ __html: t('servicesPage.listItem4') as string }} />
                        <li className="w-para" dangerouslySetInnerHTML={{ __html: t('servicesPage.listItem5') as string }} />
                        <li className="w-para" dangerouslySetInnerHTML={{ __html: t('servicesPage.listItem6') as string }} />
                        <li className="w-para" dangerouslySetInnerHTML={{ __html: t('servicesPage.listItem7') as string }} />
                        <li className="w-para" dangerouslySetInnerHTML={{ __html: t('servicesPage.listItem8') as string }} />
                        <li className="w-para" dangerouslySetInnerHTML={{ __html: t('servicesPage.listItem9') as string }} />
                        <li className="w-para" dangerouslySetInnerHTML={{ __html: t('servicesPage.listItem10') as string }} />
                        <li className="w-para" dangerouslySetInnerHTML={{ __html: t('servicesPage.listItem11') as string }} />
                        <li className="w-para" dangerouslySetInnerHTML={{ __html: t('servicesPage.listItem12') as string }} />
                    </ul>
                </div>
            </main>
        </>
    );
};

export default Services;